import React from 'react';

import { Field, useField } from 'formik';
import { Form, Row } from 'react-bootstrap';

interface IRadioPickerFieldProps {
  name: string;
  label?: string;
  options: ISelectOption[];
  dataTestId?: string;
}

const RadioPickerField = ({ label, name, options, dataTestId }: IRadioPickerFieldProps) => {
  const [field, meta, helpers] = useField(name);
  const invalid = meta.touched && meta.error ? true : false;
  const { setValue, setTouched } = helpers;

  const handleClick = (option: ISelectOption) => {
    setValue(option.value);
    setTouched(true, false);
  };

  return (
    <>
      <div data-test={`${dataTestId}-radio-picker`} className="d-flex flex-column mb-3">
        {label && <Form.Label className="mb-2">{label}</Form.Label>}
        {options.map((option, key) => (
          <Form.Label key={key}>
            <Form.Group as={Row} className="form-group cursor-pointer mb-0">
              <div className="d-flex w-100 align-items-center">
                <Field
                  data-test={`${dataTestId}-${option.value}`}
                  type="radio"
                  name="type"
                  className="w-15"
                  checked={option.value === field.value}
                  onChange={() => handleClick(option)}
                />
                {option.icon && <img src={option.icon} alt={option.label} className="ms-3" />}
                <p className="m-0 ms-3 font-weight-normal">{option.label}</p>
              </div>
            </Form.Group>
          </Form.Label>
        ))}
      </div>
      {invalid && (
        <Form.Control.Feedback className="d-block" type="invalid">
          {meta.error}
        </Form.Control.Feedback>
      )}
    </>
  );
};

export default RadioPickerField;
